// Generated by `bazel run i18n`. Do not edit by hand.
import voiceNote_2fc77e7c from "./en/src--components--voice-note.json";
import components_80f8d596 from "./en/src--components.json";
import steps_7f192d3c from "./en/src--flow--components--steps.json";
import components_6e151a35 from "./en/src--flow--components.json";
import hooks_9ba3ef56 from "./en/src--hooks.json";
import receivingSource_f58bdecc from "./en/src--receiving-source.json";
import utils_bae51d68 from "./en/src--utils.json";
import src_c1a2d0b5 from "./en/src.json";

export default Object.assign(
  {},
  voiceNote_2fc77e7c,
  components_80f8d596,
  steps_7f192d3c,
  components_6e151a35,
  hooks_9ba3ef56,
  receivingSource_f58bdecc,
  utils_bae51d68,
  src_c1a2d0b5,
);
